import React, { FC } from 'react'
import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiButton } from '@elastic/eui'

export interface TabPageHeaderProps {
    title: string
}

const TabPageHeader: FC<TabPageHeaderProps> = ({
    title
}) => {
    return (
        <>
            <EuiFlexGroup justifyContent="spaceBetween" alignItems="center">
                <EuiFlexItem grow={false}>
                    <EuiTitle size="m">
                        <h3>{title}</h3>
                    </EuiTitle>
                </EuiFlexItem>
            </EuiFlexGroup>

            <EuiHorizontalRule />
        </>
    )
}

export default TabPageHeader 